module.exports = __webpack_public_path__ + "img/serve.87d488a3.png";